module.exports = __webpack_public_path__ + "static/media/oil_change.5884df66.svg";